import React from 'react'
import { cn } from '../../utils/cn'

interface ModernButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'warning'
  size?: 'sm' | 'md' | 'lg'
 loading?: boolean
 children: React.ReactNode
}

export const ModernButton: React.FC<ModernButtonProps> = ({
 variant = 'primary',
 size = 'md',
 loading = false,
 className,
 children,
 disabled,
 ...props
}) => {
 const baseClasses = 'inline-flex items-center justify-center font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-150 active:scale-[0.98]'

const variants = {
  primary: 'bg-accent text-white hover:bg-accent/90 focus:ring-accent shadow-sm',
  secondary: 'bg-surface text-foreground border border-border hover:bg-surface/80 focus:ring-accent',
  outline: 'bg-transparent border border-border text-foreground hover:bg-surface focus:ring-accent',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
  warning: 'bg-[#f59e0b] text-white hover:bg-[#d97706] focus:ring-warning'
  }

 const sizes = {
 sm: 'px-3 py-1.5 text-xs',
 md: 'px-4 py-2 text-sm',
 lg: 'px-6 py-3 text-base'
 }
 
 return (
 <button
 className={cn(
 baseClasses,
 variants[variant],
 sizes[size],
 (disabled || loading) && 'opacity-50 cursor-not-allowed',
 className
 )}
 disabled={disabled || loading}
 {...props}
 >
 {loading && (
 <svg
 className="animate-spin -ml-1 mr-2 h-4 w-4"
 xmlns="http://www.w3.org/2000/svg"
 fill="none"
 viewBox="0 0 24 24"
 >
 <circle
 className="opacity-25"
 cx="12"
 cy="12"
 r="10"
 stroke="currentColor"
 strokeWidth="4"
 />
 <path
 className="opacity-75"
 fill="currentColor"
 d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
 />
 </svg>
 )}
 {children}
 </button>
 )
}
